import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const ArsenalHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Arsenal"));
        
        const fav = {
            teamName: "Arsenal",
            teamLogo: "https://upload.wikimedia.org/wikipedia/hif/8/82/Arsenal_FC.png",
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
        const fetchFavorites = async () => {
            try {
                    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Arsenal`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                });
    
                if (!res.ok) {
                    console.log("No favorites found or error fetching");
                    setFavoritesLoaded(true);
                    return;
                }
                const data = await res.json();
    
                // highlight team star
                setIsTeamFavorite(data.team?.isFavorite || false);
    
                // highlight player stars
                const playerKeys = data.players
                    .filter(p => p.isFavorite && p.name.startsWith("Arsenal"))
                    .map(p => p.name);  
                setStarredPlayers(playerKeys);
                setFavoritesLoaded(true);

            } catch (err) {
                console.error("Error fetching favorites", err);
            }
        };
    
        fetchFavorites();
    }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Arsenal"]}
                        alt="Arsenal"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>Arsenal</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal);
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Arsenal" /></p>
                        <p><span className="soccer-label">Stadium:</span> Emirates Stadium</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Mikel Arteta</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Albert Stuivenberg, Miguel Molina, Miguel Molina</p>
                    </div>
                </section>

            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Arsenal"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Arsenal" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Arsenal" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Has never been relegated from the Premier League</p>
                        <br />
                        <p>• Only team in the Premier League to go Invincible in the 2003/2004 season, where they didn't lose a single game</p>
                        <br />
                        <p>• Thierry Henry is the club's all time top scorer, with 228 goals</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ArsenalHome;